import { SSO_AUTH_URL } from '@/constant';
import { useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { useSuspenseQuery } from '@apollo/client';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/signin/')({
  component: component,
});

export const SIGN_IN_PAGE_QUERY = graphql(/* GraphQL */ `
  query SignInPageQuery {
    currentGloplaUser {
      ...GloplaUserLoginCheck
    }
  }
`);

export const GLOPLA_USER_LOGIN_CHECK_FRAGMENT = graphql(`
  fragment GloplaUserLoginCheck on GloplaUser {
    id
  }
`);

function component() {
  const { error, data } = useSuspenseQuery(SIGN_IN_PAGE_QUERY);
  const gloplaUserData = useFragment(
    GLOPLA_USER_LOGIN_CHECK_FRAGMENT,
    data.currentGloplaUser,
  );

  if (error) {
    throw error;
  }

  // ログイン済みであれば、トップページにリダイレクト  規約未同意や開講データ未選択はここでは考慮せず、TOPページでの判定に委ねる
  if (gloplaUserData) {
    return <Navigate to="/" replace={true} />;
  }

  window.location.href = SSO_AUTH_URL;

  return null;
}
